import React from 'react'



function NewsMediaBelow() {

    return (
        <section className="news-media-below">

        <h3>News and Media Coming Soon</h3>

        </section>
        ) ;
}

export default NewsMediaBelow